import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    TextField,
    makeStyles,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { closeEditItemTypesDialog } from "./item-types-edit-slice";
import { db } from "../../../../firebase";
import { useEffect, useState } from "react";
import { editItemTypesService } from "./item-types-edit-service";
import { showErrorSnackbar } from "../../../shared/snackbar/snackbar-slice";

const useStyles = makeStyles((theme) => ({
    button: {
        background: "#111111",
        color: "#fbbbd3",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    buttonText: {
        color: "#111111",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    title: {
        background:"#111111",
    },
}));

const initiaFormData = {
    code: "",
    name: "",
    description: "",
};

const ItemTypesEdit = () => {
    const classes = useStyles();
    const itemTypesData = useSelector((state) => state.itemTypesEditSlice.itemTypesEdit);
    const showDialog = useSelector((state) => state.itemTypesEditSlice.showDialog);
    const isLoading = useSelector((state) => state.itemTypesEditSlice.isLoading);
    const [formData, setFormData ] = useState(initiaFormData);
    const dispatch = useDispatch();

    const itemTypesId = itemTypesData.id;

    // get data
    useEffect(() => {
        if (showDialog) {
            setFormData(itemTypesData);
        }
    }, [showDialog, itemTypesData]);

    // handle input
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          [name]: value
        });
    };

    // handle edit
    const handleEditSubmit = async (e) => {
        e.preventDefault();  
       
        try {
            await editItemTypesService(dispatch, db, "item_types", itemTypesId, formData);
        } catch (e) {
            dispatch(showErrorSnackbar("Something went wrong while trying to edit."));
            console.error("ItemTypesEdit handleEditSubmit error: ", e);
        }

        handleEditClose();
    };

    // handle close edit
    const handleEditClose = () => {
        setFormData(initiaFormData);
        dispatch(closeEditItemTypesDialog());
    };

    return (
        <>
            <Dialog
                open={showDialog}
            >
                <DialogTitle className={classes.title}>
                    Edit Item Type
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <TextField
                                id="filled-basic"
                                label="Code"
                                variant="filled"
                                fullWidth
                                name="code"
                                value={formData.code}
                                onChange={handleInputChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <TextField
                                id="filled-basic"
                                label="Name"
                                variant="filled"
                                fullWidth
                                name="name"
                                value={formData.name}
                                onChange={handleInputChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <TextField
                                id="filled-basic"
                                label="Description"
                                variant="filled"
                                fullWidth
                                name="description"
                                value={formData.description}
                                onChange={handleInputChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        className={classes.button}
                        onClick={handleEditSubmit}
                        disabled={isLoading}
                    >
                        {
                            isLoading ? (
                                "Saving..."
                            ) : (
                                "Save Changes"
                            )
                        }
                    </Button>
                    <Button
                        variant="text"
                        className={classes.buttonText}
                        onClick={handleEditClose}
                        disabled={isLoading}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default ItemTypesEdit;